import React, { useEffect, useState } from 'react';
import { Box, ButtonBase, InputBase, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import Text from '../../../../../components/Text';
import { AutoCompleteSelect } from '../../../../../components';
import StyleButton from '../../../../../components/StyleButton';
import { AddIcon, DeleteIcon } from '../../../../../components/Icon';
import { bedStatusAPI } from '../../../../../apis';
import { alertMsg } from '../../../../../apis/commlogic';
import { i18n } from '../../../../../language';
import { getArrayRandomKey } from '../../../../../utils';

const APIMapping = () => {
  const classes = useStyles();
  const rouList = useSelector((state) => state.rouList);
  const emptyHeaderObj = {
    headerKey: '',
    headerValue: '',
  };
  const [detail, setDetail] = useState({
    orderServiceBy: null,
    sendRequestBy: null,
    createRequestUrl: '',
    completeRequestUrl: '',
    getRequestStatusUrl: '',
    deleteRequestUrl: '',
    getServiceTypeUrl: '',
    getLocationUrl: '',
    headerMapping: [],
  });

  const handleUpdateDetail = (type) => (value) => {
    setDetail((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const getHospCleansingSetting = async () => {
    try {
      const { result } = await bedStatusAPI.getHospCleansingSetting();
      const headerMappingList = result?.orderServiceBy === 'LocalSystem' ? result?.headerMapping : [emptyHeaderObj];
      setDetail({
        orderServiceBy: result?.orderServiceBy ?? null,
        sendRequestBy: result?.sendRequestBy ?? 'Discharged',
        createRequestUrl: result?.createRequestUrl ?? '',
        completeRequestUrl: result?.completeRequestUrl ?? '',
        getRequestStatusUrl: result?.getRequestStatusUrl ?? '',
        deleteRequestUrl: result?.deleteRequestUrl ?? '',
        getServiceTypeUrl: result?.getServiceTypeUrl ?? '',
        getLocationUrl: result?.getLocationUrl ?? '',
        headerMapping: headerMappingList,
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getHospCleansingSetting();
  }, [rouList]);

  const orderServiceOptions = [
    {
      text: 'N/A',
      value: null,
    },
    {
      text: 'ADS',
      value: 'ADS',
    },
    {
      text: 'Local System',
      value: 'LocalSystem',
    },
  ];

  const getApiParams = (name) => {
    if (detail?.orderServiceBy !== 'LocalSystem') {
      return null;
    }
    if (name !== 'headerMapping') {
      return detail?.[name] || null;
    } else {
      return _.filter(detail?.headerMapping, (item) => item?.headerKey && item?.headerValue);
    }
  };

  const handleSave = async () => {
    try {
      const params = {
        orderServiceBy: detail?.orderServiceBy,
        sendRequestBy: detail?.sendRequestBy,
        createRequestUrl: getApiParams('createRequestUrl'),
        completeRequestUrl: getApiParams('completeRequestUrl'),
        getRequestStatusUrl: getApiParams('getRequestStatusUrl'),
        deleteRequestUrl: getApiParams('deleteRequestUrl'),
        getServiceTypeUrl: getApiParams('getServiceTypeUrl'),
        getLocationUrl: getApiParams('getLocationUrl'),
        headerMapping: getApiParams('headerMapping'),
      };
      await bedStatusAPI.updateCleansingSetting(params);
      alertMsg(i18n.t('DUTYASSIGN_SAVE_SUCCESS_ALERT'), 'alert-success', 'success');
    } catch (error) {
      console.log(error);
    }
  };

  const requestAtOptions = [
    {
      text: 'Order Discharge',
      value: 'OrderDischarge',
    },
    {
      text: 'Discharged',
      value: 'Discharged',
    },
  ];
  const localSystemAPIInfoList = [
    {
      text: 'Create Request URL',
      apiField: 'createRequestUrl',
    },
    {
      text: 'Get Request Status URL',
      apiField: 'getRequestStatusUrl',
    },
    {
      text: 'Delete Request URL',
      apiField: 'deleteRequestUrl',
    },
    {
      text: 'Get Service Type URL',
      apiField: 'getServiceTypeUrl',
    },
    {
      text: 'Get Location URL',
      apiField: 'getLocationUrl',
    },
    // {
    //   text: 'Complete Request URL',
    //   apiField: 'completeRequestUrl',
    // },
  ];
  const inputChange = (name, val) => {
    setDetail((prev) => ({
      ...prev,
      [name]: val,
    }));
  };
  const handleHeaderMapping = (type, index) => {
    let headerParamsList = detail?.headerMapping;
    type === 'add' ? headerParamsList.push(emptyHeaderObj) : headerParamsList.splice(index, 1);
    setDetail((prev) => ({
      ...prev,
      headerMapping: headerParamsList,
    }));
  };
  const headerMappingInputChange = (index, key, val) => {
    let headerParamsList = detail?.headerMapping;
    headerParamsList[index][key] = val;

    setDetail((prev) => ({
      ...prev,
      headerMapping: headerParamsList,
    }));
  };

  return (
    <Box display="flex" flexDirection="column" height="100%" justifyContent="space-between">
      <Box>
        <Text color="#333333" fontSize="1.5rem" fontWeight="700">
          API Mapping
        </Text>
        <Box mt="1.25rem" mb="1.25rem" width="20rem">
          <Text color="#666666" fontSize="0.875rem" mb="0.75rem">
            Order Service By
          </Text>
          <AutoCompleteSelect
            itemList={orderServiceOptions}
            value={detail.orderServiceBy}
            onChange={handleUpdateDetail('orderServiceBy')}
          />
        </Box>
        {detail.orderServiceBy !== null && (
          <Box mb="1rem">
            <Box width="20rem">
              <Text color="#666666" fontSize="0.875rem" mb="0.75rem">
                Send request at
              </Text>
              <AutoCompleteSelect
                itemList={requestAtOptions}
                value={detail?.sendRequestBy}
                onChange={handleUpdateDetail('sendRequestBy')}
              />
            </Box>
          </Box>
        )}

        {Boolean(detail.orderServiceBy) && detail.orderServiceBy !== 'ADS' && (
          <>
            <Box mb="1.87rem">
              <Text color="#2E4469" fontSize="1.25rem" fontWeight="700">
                Local System Detail
              </Text>
              <Text color="#7D86A9" fontSize="1rem" mt="0.25rem">
                late update time : 14:37 17-06-2024
              </Text>
            </Box>

            <Box pt="1.87rem" pb="1rem" mb="1.87rem" borderBottom="1px solid #E5E5E5" borderTop="1px solid #E5E5E5">
              <Text color="#2E4469" fontSize="1.25rem" fontWeight="700" mb="1.87rem">
                Local System API Authorization
              </Text>

              <Box display="flex" flexDirection="column" gridGap="1rem">
                {_.map(detail?.headerMapping, (item, index) => (
                  <Box key={getArrayRandomKey(index, 'api-header-authorization')} display="flex" gridGap="1rem">
                    <Box display="flex" alignItems="center" width="20%" height="3.5rem">
                      <InputBase
                        className={classes.InputBase}
                        placeholder={i18n.t('SETTING_PLEASE_INPUT')}
                        value={item?.headerKey}
                        onChange={(e) => headerMappingInputChange(index, 'headerKey', e?.target?.value)}
                      />
                    </Box>

                    <Box display="flex" width="60%" gridGap="1.25rem">
                      <InputBase
                        className={classes.InputBase}
                        placeholder={i18n.t('SETTING_PLEASE_INPUT')}
                        value={item?.headerValue}
                        onChange={(e) => headerMappingInputChange(index, 'headerValue', e?.target?.value)}
                      />
                    </Box>

                    <Box display="flex" width="10%" alignItems="center" gridGap="1.25rem">
                      {detail?.headerMapping?.length !== 1 && (
                        <StyleButton
                          Icon={DeleteIcon}
                          iconStyle={{ color: '#538FFF' }}
                          width="2.25rem"
                          height="2.25rem"
                          borderRadius="0.5rem"
                          onClick={() => handleHeaderMapping('del', index)}
                        />
                      )}
                      {index === detail?.headerMapping?.length - 1 && (
                        <ButtonBase className={classes.addBtn} onClick={() => handleHeaderMapping('add')}>
                          <AddIcon /> Add
                        </ButtonBase>
                      )}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>

            <Box>
              <Text color="#2E4469" fontSize="1.25rem" fontWeight="700" mb="1.25rem">
                Local System API URL info
              </Text>
              <Box display="flex" flexDirection="column" gridGap="1.88rem" maxWidth="60rem">
                {_.map(localSystemAPIInfoList, (item, index) => (
                  <Box key={getArrayRandomKey(index, 'api-url-info')}>
                    <Text color="#666666" fontSize="0.875rem" mb="0.75rem">
                      {item?.text}
                    </Text>
                    <InputBase
                      className={classes.InputBase}
                      placeholder={i18n.t('SETTING_PLEASE_INPUT')}
                      value={detail?.[item?.apiField]}
                      onChange={(e) => inputChange(item?.apiField, e?.target?.value)}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          </>
        )}
      </Box>
      <Box p="2rem 0" display="flex" justifyContent="center">
        <StyleButton text="Save" width="7.25rem" type="fill" onClick={handleSave} />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  autoCompleteBox: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    '&>div:first-child': {
      flex: 1,
      maxWidth: '62.5rem',
    },
  },
  addBtn: {
    color: '#538FFF',
    fontSize: '0.875rem',
    gap: '0.5rem',
    fontFamily: 'NotoSans-Bold',
  },
  btnBox: {
    display: 'flex',
    // marginLeft: '1.25rem',
    // width: '4rem',
    justifyContent: 'flex-start',
  },
  InputBase: {
    height: '3.5rem',
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    width: '100%',
    paddingLeft: '1.25rem',
    '& .MuiInputBase-input': {
      fontSize: '1rem',
      color: '#2e4469',
      fontFamily: 'NotoSans-Medium',
    },
  },
}));

export default APIMapping;
